import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

type StyleEntry =
  | SystemStyleObject<Theme>
  | ((theme: Theme) => SystemStyleObject<Theme>);

export const styles = {
  dialog: (theme: Theme): SystemStyleObject<Theme> => ({
    '& .MuiDialog-scrollPaper': {
      alignItems: 'flex-start',
    },
    '& .MuiDialog-paperScrollBody': {
      verticalAlign: 'top',
    },
    '& .MuiDialog-paper': {
      borderRadius: '10px',
      color: theme.palette.primary.dark,
      maxWidth: '50%',
      overflow: 'hidden',
      background:
        theme.palette.mode === 'light' ? theme.palette.gray[400] : undefined,
    },
  }),
  rootOptions: (showConfigName?: boolean): SystemStyleObject<Theme> => ({
    height: showConfigName ? 'calc(100vh - 320px)' : 'calc(100vh - 228px)',
    overflow: 'auto',
    marginBottom: '24px',
  }),
  targetRowTop: (theme: Theme): SystemStyleObject<Theme> => ({
    borderTop: `2px solid ${theme.palette.primary.main}`,
  }),
  targetRowBottom: (theme: Theme): SystemStyleObject<Theme> => ({
    borderBottom: `2px solid ${theme.palette.primary.main}`,
  }),
  listItem: {
    padding: '4px 16px',
    textAlign: 'left',
  } as SystemStyleObject<Theme>,
  listItemButton: (theme: Theme): SystemStyleObject<Theme> => ({
    width: '100%',
    textAlign: 'left',
    color: theme.palette.text.primary,
  }),
  headerColumn: (theme: Theme): SystemStyleObject<Theme> => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '8px 16px',
    color: theme.palette.text.primary,
  }),
  applyButton: {
    minWidth: 105,
    borderRadius: '4px',
  } as SystemStyleObject<Theme>,
} satisfies Record<string, StyleEntry | ((showConfigName?: boolean) => SystemStyleObject<Theme>)>;
